import {
  ACH_EMAIL_ID,
  atinRange,
  atinRegex,
  invalidSSNs,
  itinRanges,
  itinRegex,
  MAIL_BODY,
  MAILTO_SUBJECT,
  ssnRanges,
  ssnRegex, VC,
  VC_EMAIL_ID, VCN,
  VCN_EMAIL_ID,
} from "./Constants";
import {ACH} from "src/constants/ach-authentication-constants";

export const isRequired = (value: string) => value.trim() === "";
export const hasMaxLength = (value: string, maxLength: number) =>
  value.length > maxLength;
export const hasExactLength = (value: string, length: number) =>
  value.length === length;

export const hasLengthBetween = (
  value: string,
  minLength: number,
  maxLength: number,
): boolean => {
  const length = value.length;
  return length >= minLength && length <= maxLength;
};
export const isValidEmail = (value: string) =>
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?<!\.com\.com)$/.test(value);
export const isValidAccountNumber = (value: string) => /^\d{1,17}$/.test(value);


export const isValidTaxPayerId = (value: string) => {
  // Accept any numeric value up to 9 digits
  return /^\d{1,9}$/.test(value);
};
export const calculateWorkingCapital = (
  sales: number,
  rate: number,
  days: number,
): number => {
  return ((sales * rate) / 100 / 365) * days;
};

export const calculatePercentageChange = (
  newVal: number,
  oldVal: number,
): string => {
  const change = Math.abs((newVal - oldVal) / oldVal) * 100;
  return change.toFixed(2);
};

export const openEmailClient = (contentTargetEnrollment: string) => {
  let recipient: string;

  switch (contentTargetEnrollment) {
    case VC:
      recipient = VC_EMAIL_ID;
      break;
    case VCN:
      recipient = VCN_EMAIL_ID;
      break;
    case ACH:
      recipient = ACH_EMAIL_ID;
      break;
    default:
      recipient = VC_EMAIL_ID;
  }

  const subject = MAILTO_SUBJECT;
  const body = encodeURIComponent(MAIL_BODY).replace(/%0A/g, "%0D%0A");
  return `mailto:${recipient}?subject=${subject}&body=${body}`;
};
export function getRedirectPath(pathName: string, pagePath: any): string {
  switch (true) {
    case pathName.includes(pagePath.faq):
      return pagePath.faq;
    case pathName.includes(pagePath.paymentTerm):
      return pagePath.paymentTerm;
    case pathName.includes(pagePath.errorPage):
      return pagePath.errorPage;
    case pathName.includes(pagePath.thanksPage):
      return pagePath.thanksPage;
    case pathName.includes(pagePath.achDefaultEmailPage):
      return pagePath.achDefaultEmailPage;
    case pathName.includes(pagePath.exisistingSessionPage):
      return pagePath.exisistingSessionPage;
    default:
      return "/";
  }
}